package com.essntl.uikit.components.chat.message

import androidx.compose.foundation.*
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Popup
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalFoundationApi::class)
@Composable
fun EsMessage(
    message: MessageUiState,
    isSameSender: Boolean,
    senderName: String?,
    onReact: (messageId: String, emoji: String?) -> Unit,
) {
    var isReactPopupOpen by rememberSaveable { mutableStateOf(false) }
    var popupOffset by remember { mutableStateOf(Offset.Zero) }
    var selectedEmoji by remember(message.reactions) {
        mutableStateOf(message.reactions.firstOrNull { it.fromMe }?.emoji)
    }

    Box(
        modifier = Modifier
            .fillMaxSize(),
    ) {

        Row(
            modifier = Modifier
                .align(
                    if (message.isCurrentUserSender)
                        Alignment.CenterEnd else
                        Alignment.CenterStart,
                ),
            verticalAlignment = Alignment.Bottom,
        ) {
            if (message.isCurrentUserSender) {
                Sender(
                    message = message,
                    senderName = senderName,
                    modifier = Modifier
                        .onGloballyPositioned { coordinates ->
                            if (isReactPopupOpen) {
                                val position = coordinates.localToRoot(Offset.Zero)
                                popupOffset = position.copy(y = -100F)
                            }
                        }
                        .combinedClickable(
                            onClick = {
                                isReactPopupOpen = false
                            },
                            onLongClick = {
                                isReactPopupOpen = true
                            },
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null,
                        ),
                )
            } else {
                Receiver(
                    message = message,
                    isSameSender = isSameSender,
                    modifier = Modifier
                        .onGloballyPositioned { coordinates ->
                            if (isReactPopupOpen) {
                                val position = coordinates.localToRoot(Offset.Zero)
                                popupOffset = position.copy(y = -100F, x = 0F)
                            }
                        }
                        .combinedClickable(
                            onClick = {
                                isReactPopupOpen = false
                            },
                            onLongClick = {
                                isReactPopupOpen = true
                            },
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null,
                        ),
                )
            }
        }

        if (isReactPopupOpen) {
            Popup(
                offset = IntOffset(popupOffset.x.toInt(), popupOffset.y.toInt()),
                onDismissRequest = { isReactPopupOpen = false },
            ) {
                Box(
                    modifier = Modifier
                        .background(
                            color = MaterialTheme.esColorScheme.bgSecondary,
                            shape = RoundedCornerShape(50),
                        )
                        .border(
                            width = 1.dp,
                            color = MaterialTheme.esColorScheme.borderPrimary,
                            shape = RoundedCornerShape(50),
                        )
                        .padding(5.dp),
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        MessageReact.entries.forEach {
                            Box(
                                modifier = Modifier
                                    .size(32.dp)
                                    .background(
                                        color = if (getReact(selectedEmoji) == it)
                                            MaterialTheme.esColorScheme.bgSecondaryHover
                                        else
                                            Color.Transparent,
                                        shape = CircleShape,
                                    )
                                    .clip(CircleShape)
                                    .clickable {
                                        val newReaction =
                                            if (it.getEmojiString == selectedEmoji) null else it.getEmojiString
                                        selectedEmoji = newReaction
                                        isReactPopupOpen = false
                                        onReact(message.id, newReaction)
                                    },
                                contentAlignment = Alignment.Center,
                            ) {
                                Text(
                                    it.getEmojiString,
                                    style = MaterialTheme.esTypography.h3Regular24,
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}